import React from 'react';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import McListTableRow from '../../components/mcListTableRow';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _, { times } from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql } from '@apollo/client';
import moment from 'moment';

// import MemoryCardTable from './MemoryCardTable';
import DataTableCompact from '../../components/DataTableCompact';
import jwtDecode from 'jwt-decode';
// import { Data } from './data';
import PieChart from './PieChart';
import AssetsTable from './AssetsTable';
import EditAsset from '../../components/assets/editAsset';
import AssignReceiveAsset from '../../components/assets/assignReceiveAsset';

const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const getAssetsEQs = gql`
	query EqAssetList($filters: AssetFiltersInput) {
		eqAssetList(filters: $filters) {
			currentPage
			hasNextPage
			hasPrevPage
			limit
			nextPage
			prevPage
			totalDocs
			totalPages
			data {
				qrCode
				manufacturer
				manufacturerId
				type
				status
				allocatedAt
				employees {
					designation
					name
					dp_signed_url
					_id
				}
			}
		}
	}
`;
const getEmployeeDefaultfilters = gql`
	query EmployeeDefaultfilters {
		employeeDefaultfilters {
			designation
			department
			workspaceId
			employees {
				_id
				displayName
				fullName
			}
		}
	}
`;

class AssetsMemoryCards extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			assetsList: null,
			assetsSummary: null,
			limit: 30,
			page: 1,
			isLoading: true,
			currentViewPage: 1,
			isPageLoading: false,
			search: '',
			searchValue: '',
			showAssignReceiveAsset: false,
			modalType: 'assign',
			barnchesFilters2: [],
			modalData: {},

			branchesActiveFilter: [],
			statusActiveFilter: [],
			typesActiveFilter: [],
			assignedToFilters: [],
			assignedToActiveFilter: [],

			columns: [
				{ title: 'Type' },
				{ title: 'Model' },
				{ title: 'Qr code' },
				{ title: 'Assigned to' },
				// { title: 'Workspace' },
				{ title: 'Assigned on' },
				{ title: 'Status' },
			],
			statusFilters: [
				{ key: 'active', name: 'Active' },
				{ key: 'inactive', name: 'Inactive' },
				{ key: 'damaged', name: 'Damaged' },
			],
			availableFilters: [
				{ key: 'true', name: 'Available' },
				{ key: 'false', name: 'Not Available' },
			],
			availableActiveFilter: null,

			assetType: 'equipments',
		};
	}

	componentDidMount = async () => {
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}

				if (subString[0] && subString[0] === 'branches') {
					json = {
						filters: {
							...json.filters,

							branchId: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'availability') {
					json = {
						filters: {
							...json.filters,

							isAvailable: subString[1] === 'true' ? true : false,
						},
					};
				}
				if (subString[0] && subString[0] === 'types') {
					json = {
						filters: {
							...json.filters,

							type: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'status') {
					json = {
						filters: {
							...json.filters,

							status: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'assignedTo') {
					json = {
						filters: {
							...json.filters,

							assignedTo: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'search') {
					json = {
						filters: {
							...json.filters,

							search: subString[1],
						},
					};
				}

				if (subString[0] === 'limit') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				} else if (subString[0] === 'page') {
					this.setState({
						currentViewPage: parseInt(subString[1]),
					});
				} else if (subString[0] === 'availability') {
					this.setState({
						availableActiveFilter: subString[1],
					});
				} else if (subString[0] === 'branches') {
					this.setState({
						branchesActiveFilter: subString[1].split(','),
					});
				} else if (subString[0] === 'types') {
					this.setState({
						typesActiveFilter: subString[1].split(','),
					});
				} else if (subString[0] === 'status') {
					this.setState({
						statusActiveFilter: subString[1].split(','),
					});
				} else if (subString[0] === 'assignedTo') {
					this.setState({
						assignedToActiveFilter: subString[1].split(','),
					});
				} else if (subString[0] === 'search') {
					this.setState({
						searchValue: subString[1],
					});
				}

				count++;
			}
		} else {
			json = {
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
				},
			};
		}
		this.getAssetsEquipments(getAssetsEQs, json);
		this.getBranchList2(getBranchList);
		this.getEmployeeDefaultfilters(getEmployeeDefaultfilters);
	};

	showAssignReceiveAsset = (e, type) => {
		this.setState({
			showAssignReceiveAsset: !this.state.showAssignReceiveAsset,
			modalType: type,
		});
	};

	handleActiveFilter = async (e, type, key) => {
		let array;

		array = [...this.state[`${type}ActiveFilter`]];

		if (array.includes(key) == false) {
			array.push(key);
		} else {
			const index = array.indexOf(key);
			if (index > -1) {
				array.splice(index, 1); // 2nd parameter means remove one item only
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => {
				this.fetchMoreAssets();
			},
		);
	};
	handleclearSelection = (e, type) => {
		if (type === 'available') {
			this.setState(
				{
					[`${type}ActiveFilter`]: null,
					currentViewPage: 1,
					isPageLoading: true,
				},
				() => this.fetchMoreAssets(),
			);
		} else {
			this.setState(
				{
					[`${type}ActiveFilter`]: [],
					currentViewPage: 1,
					isPageLoading: true,
				},
				() => this.fetchMoreAssets(),
			);
		}
	};
	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreAssets();
				},
			);
		}
	};
	handleSummaryClick = (type) => {
		this.setState(
			{
				typesActiveFilter: [type],
			},
			() => {
				this.fetchMoreAssets();
			},
		);
	};

	fetchMoreAssets = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;
		if (_.size(this.state.branchesActiveFilter) > 0)
			queryString = `${queryString}&branches=${this.state.branchesActiveFilter.toString()}`;
		if (_.size(this.state.typesActiveFilter) > 0)
			queryString = `${queryString}&types=${this.state.typesActiveFilter.toString()}`;
		if (_.size(this.state.statusActiveFilter) > 0)
			queryString = `${queryString}&status=${this.state.statusActiveFilter.toString()}`;
		if (_.size(this.state.assignedToActiveFilter) > 0)
			queryString = `${queryString}&assignedTo=${this.state.assignedToActiveFilter.toString()}`;
		if (_.size(this.state.searchValue) > 0)
			queryString = `${queryString}&search=${this.state.searchValue.toString()}`;
		if (
			this.state.availableActiveFilter !== null &&
			_.size(this.state.availableActiveFilter) > 0
		)
			queryString = `${queryString}&availability=${this.state.availableActiveFilter.toString()}`;
		this.props.navigate(`/${this.props.params.vendorID}/assets/equipments${queryString}`);

		let json = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
			},
		};
		let assetsFilter = {};

		if (_.size(this.state.branchesActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					branchId: this.state.branchesActiveFilter,
				},
			};
			assetsFilter = {
				...assetsFilter,
				filters: {
					...assetsFilter.filters,
					branchId: this.state.branchesActiveFilter,
				},
			};
		}
		if (_.size(this.state.typesActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					type: this.state.typesActiveFilter,
				},
			};
		}
		if (_.size(this.state.statusActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					status: this.state.statusActiveFilter,
				},
			};
		}
		if (_.size(this.state.assignedToActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					assignedTo: this.state.assignedToActiveFilter,
				},
			};
		}
		if (_.size(this.state.searchValue) > 0) {
			json = {
				filters: {
					...json.filters,
					search: this.state.searchValue,
				},
			};
		}
		if (
			this.state.availableActiveFilter !== null &&
			_.size(this.state.availableActiveFilter) > 0
		) {
			json = {
				filters: {
					...json.filters,
					isAvailable: this.state.availableActiveFilter === 'true' ? true : false,
				},
			};
			assetsFilter = {
				...assetsFilter,
				filters: {
					...assetsFilter.filters,
					isAvailable: this.state.availableActiveFilter === 'true' ? true : false,
				},
			};
		}

		this.getAssetsEquipments(getAssetsEQs, json);
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				// isPageLoading: true,
			},
			async () => {
				await this.fetchMoreAssets();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					// isPageLoading: true,
				},
				async () => {
					await this.fetchMoreAssets();
				},
			);
		}
	};

	applyFilter = (filter, type) => {
		if (type === 'available') {
			this.setState(
				{
					[`${type}ActiveFilter`]: filter,
					currentViewPage: 1,
					assetsList: [],
					isPageLoading: true,
				},
				() => {
					this.fetchMoreAssets();
				},
			);
		} else {
			this.setState(
				{
					[`${type}ActiveFilter`]: filter,
					currentViewPage: 1,
					assetsList: [],
					isPageLoading: true,
				},
				() => {
					this.fetchMoreAssets();
				},
			);
		}
	};
	handleChangeSelect = (e) => {
		this.setState({ assetType: e.target.value }, () => {
			if (e.target.value === 'assets') {
				this.props.navigate(`/${this.props.params.vendorID}/${e.target.value}`);
			} else {
				this.props.navigate(`/${this.props.params.vendorID}/assets/${e.target.value}`);
			}
		});
	};
	render() {
		return (
			<div className="layout-wrapper">
				{this.state.assetsList ? (
					<div className="container">
						<div className="searchContainer">
							<div className="title shoots-header-filters-container">
								<select
									className="asset-select"
									value={this.state.assetType}
									onChange={(e) => this.handleChangeSelect(e)}
								>
									<option value={'assets'}>Assets</option>
									<option value={'equipments'}>Equipments</option>
									<option value={'memory-cards'}>Memory Cards</option>
								</select>
								<a
									className="asset-select"
									style={{ borderRight: 0 }}
									onClick={(e) => this.showAssignReceiveAsset(e, 'assign')}
								>
									Assign
								</a>
								<a
									className="asset-select"
									style={{ borderRight: 0 }}
									onClick={(e) => this.showAssignReceiveAsset(e, 'receive')}
								>
									Receive
								</a>
							</div>
						</div>
						<div
							className="searchContainer"
							style={{
								right: 0,
								width: 'fit-content',
								background: 'none',
								height: 86,
							}}
						>
							<div className="title shoots-header-filters-container">
								<Filter
									type={'branches'}
									label={'Branches'}
									version="v2"
									filters={this.state.barnchesFilters2}
									activeFilter={this.state.branchesActiveFilter}
									handleActiveFilter={(e, status, key) => {
										this.handleActiveFilter(e, 'branches', key);
									}}
									clearSelection={(e) => this.handleclearSelection(e, 'branches')}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
							</div>
							{/* </div> */}

							<div
								className="searchWrapper"
								style={
									{
										// paddingLeft: '100px',
									}
								}
							>
								<div className="search-inner-left">
									<span className="search-icon">
										<SearchIcon />
									</span>
									<input
										placeholder="Search with QrCode or Employee Name"
										// name={this.state.searchType}
										value={this.state.searchValue}
										onChange={(event) => {
											this.setState({
												searchValue: event.target.value,
											});
										}}
									/>
								</div>
								<div
									className="search-inner-right"
									onClick={() => this.fetchMoreAssets()}
								>
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a className="search-type">
											<p
												style={{
													paddingRight: '20px',
												}}
											>
												Search
											</p>
										</a>
									</span>
								</div>
							</div>
						</div>
						<div
							className={'table'}
							style={{ top: '85px', height: 'calc(100vh - 85px)' }}
						>
							<div
								className="mc-flexbod"
								style={{
									display: 'flex',
									gap: '20px',
								}}
							>
								<DataTableCompact
									tableHeaderLeftPad={35}
									isLoading={this.state.isLoading}
									tableHeader={`SHOOTS`}
									columns={this.state.columns}
									isPageLoading={this.state.isPageLoading}
									limit={this.state.limit}
									totalPages={this.state.totalPages}
									currentViewPage={this.state.currentViewPage}
									lengthOfList={this.state.lengthOfList}
									onClickNextPage={this.onClickNextPage}
									onClickPreviousPage={this.onClickPreviousPage}
									dataList={this.state.assetsList}
									goToPage={(e) => this.handleGoToPage(e)}
									module={'project'}
									searchQuery={''}
									mainFilter={''}
									tableTop={85}
								>
									{_.map(this.state.assetsList, (asset, index) => {
										return (
											<tr
											// onClick={() => {
											// 	// alert(`${asset.serialNumber}`);
											// 	this.showAssignReceiveAsset(
											// 		asset.id,
											// 		asset.type,
											// 		asset.serialNumber,
											// 		asset.qrCode,

											// 		asset?.employees[0]?.name,
											// 		asset?.employees[0]?._id,
											// 		asset.status,
											// 		asset?.branch?._id,
											// 		asset?.branch?.branchId,
											// 		asset.allocatedAt,
											// 	);
											// }}
											>
												<td className="upper-para">{asset.type}</td>
												<td
													style={{
														display: 'flex',
														flexDirection: 'column',
														gap: '5px',
													}}
												>
													<p className="upper-para">
														{asset.manufacturer}
													</p>
													<p className="lower-para">
														{asset.manufacturerId}
													</p>
												</td>
												<td
													className="upper-para"
													style={{
														textTransform: 'none',
													}}
												>
													{asset.qrCode ? asset.qrCode.toUpperCase() : ''}
												</td>
												<td>
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '8px',
														}}
													>
														{asset.status !== 'ready' &&
														asset.employees &&
														asset.employees.length > 0 ? (
															asset.employees[0].dp_signed_url !==
																null &&
															asset.employees[0].dp_signed_url !==
																'' ? (
																<img
																	style={{
																		height: '31.06px',
																		width: '31.06px',
																		minHeight: '31.06px',
																		minWidth: '31.06px',
																		borderRadius: '50%',
																	}}
																	src={
																		asset.employees[0]
																			.dp_signed_url
																	}
																	alt=""
																/>
															) : (
																<div
																	style={{
																		height: '31.06px',
																		width: '31.06px',
																		minHeight: '31.06px',
																		minWidth: '31.06px',
																		borderRadius: '50%',
																		backgroundColor: '#898989',
																	}}
																></div>
															)
														) : null}

														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
															}}
														>
															<p
																className="upper-para"
																style={{
																	maxWidth: '250px',
																	overflow: 'hidden',
																	whiteSpace: 'nowrap',
																	textOverflow: 'ellipsis',
																}}
															>
																{/* {asset.employees &&
																asset.employees.length > 0
																	? asset.employees[0].name
																	: null} */}

																{asset.status !== 'ready' &&
																asset.employees &&
																asset.employees.length > 0 ? (
																	<>
																		{asset.employees.map(
																			(emp, i) => {
																				return (
																					<span>
																						{emp.name}

																						{i !==
																						asset
																							.employees
																							.length -
																							1
																							? ','
																							: ''}
																					</span>
																				);
																			},
																		)}
																	</>
																) : (
																	<></>
																)}
															</p>
															<p className="lower-para">
																{asset.employees &&
																asset.employees.length > 0 &&
																asset.employees[0].designation !==
																	null
																	? asset.employees[0].designation
																			.replace(
																				/([a-z])([A-Z])/g,
																				'$1 $2',
																			)
																			.replace(
																				/(?:^|\s)\S/g,
																				(a) =>
																					a.toUpperCase(),
																			)
																	: '-'}
															</p>
														</div>
													</div>
												</td>

												<td>
													{asset.allocatedAt
														? moment
																.unix(asset.allocatedAt)
																.format('DD MMM YYYY')
														: '-'}
												</td>

												<td>
													<span
														className={`completed-shoots `}
														style={{
															display: 'flex',
															alignItems: 'center',
															textTransform: 'uppercase',
															fontSize: '13px',
															fontWeight: '500',
														}}
													>
														<b
															style={{
																width: '5px',
																height: '5px',
																minHeight: '5px',
																minWidth: '5px',
																borderRadius: '50%',
																backgroundColor:
																	asset.status === 'ready'
																		? '#49B217'
																		: asset.status === 'damaged'
																		? '#FF1717'
																		: 'rgb(202, 90, 79)',
																marginRight: 5,
																display: 'flex',
															}}
														></b>
														{asset.status}
													</span>
												</td>
											</tr>
										);
									})}
								</DataTableCompact>
							</div>
						</div>
					</div>
				) : (
					<div className="container">
						<LoadingBar />
					</div>
				)}
				{this.state.showAssignReceiveAsset === true ? (
					<AssignReceiveAsset
						handleClose={() =>
							this.setState({
								showAssignReceiveAsset: false,
							})
						}
						actionType={this.state.modalType}
						type={this.state.modalType + ' ' + 'Equipments'}
						assetType={'equipment'}
						assignedToOptions={this.state.assignedToOptions}
						show={this.state.showAssignReceiveAsset}
						custClass={'modal-with-no-fixed-height'}
						branchesOptions={this.state.branchesOptions}
					/>
				) : null}
				{/* )} */}
			</div>
		);
	}
}

export default withRouter(AssetsMemoryCards);
